export default __webpack_public_path__ + "static/media/gramaphone.d912e1ba.svg";